import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";

export const downloadFilesContainer = htmlE`
        <div class="is-flex is-flex-direction-column w-full h-full gap-2 is-relative download-section">
          <div id="server-read-progress-download" class="server-read-progress-download d-n">
            <div class="progress-bar">
              <div class="progress-fill"></div>
            </div>
            <div class="progress-text"></div>
          </div>

            <div id="downloadFileSection" class="is-flex is-flex-direction-column h-full">
                <div class="h-full is-flex is-align-items-center is-justify-content-center is-flex-direction-column">
                    <p class="text-base text-primaryMain has-text-weight-semibold mb-2" data-i18n-key="noFilesAvailable">No files available</p>
                    ${({ }) =>
                      utils.hasAlternateWebInterfaceImagesPath()
                        ? utils.getWebInterfaceImageTag("no-file-found.png", {
                            alt: "noFilesAvailable",
                          })
                        : `<img src="/WebInterface/new-ui/assets/images/no-file-found.png" alt="noFilesAvailable" />`}
                </div>
            </div>

            <div class="is-flex is-flex-direction-column">
                <div class="is-flex">
                  <label id="scrollWithActivityDownloadWrapper" for="scrollWithActivityDownload" class="text-xs is-hidden is-flex is-align-items-center is-cursor-pointer download-scroll-activity">
                      <input checked id="scrollWithActivityDownload" type="checkbox" />
                      <span data-i18n-key="scrollWithActivity">Scroll with activity</span>
                  </label>
                </div>

                <div id="globalDownloads" class="is-hidden bg-accentSecondary"></div>

                <div class="w-full is-flex is-justify-content-space-between is-align-items-center pt-1 download-queue-subInfo">
                    <div>
                        <label id="downloadBlockedInfo" for="remove-all-button-advanced-download" class="is-hidden text-xs text-error is-flex is-align-items-center">
                        <b><span data-i18n-key="note">Note</span>:&nbsp;</b><span data-i18n-key="downloadWillStartOnceOngoingUploadIsCompleted">Download will start once ongoing upload is completed</span>
                        </label>
                    </div>
                    <button type="button" id="remove-all-button-advanced-download" class="is-hidden primary-button is-bg-none p-0">
                        <i class="icon-trash mr-1 text-error"></i>
                        <span data-i18n-key="removeAll">${"removeAllText"}</span>
                    </button>
                </div>
            </div>
        </div>
        `;

export const noFilesAvailableTemplate = htmlE`
  <div
    class="h-full is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
  >
    <p
      class="text-base text-primaryMain has-text-weight-semibold mb-2"
      data-i18n-key="noFilesAvailable"
    >
      No files available
    </p>
    ${({ }) =>
      utils.hasAlternateWebInterfaceImagesPath()
        ? utils.getWebInterfaceImageTag("no-file-found.png", {
            alt: "noFilesAvailable",
          })
        : `<img src="/WebInterface/new-ui/assets/images/no-file-found.png" alt="noFilesAvailable" />`}
  </div>
`;

export const fileListingErrorTemplate = htmlE`
  <div
    class="h-full is-flex is-align-items-center is-justify-content-center is-flex-direction-column"
  >
    <div class="is-flex is-align-items-center is-justify-content-center mb-3">
      <i class="icon-exclamation-sign text-error fs-3rem"></i>
    </div>
    <p
      class="text-base text-error has-text-weight-semibold mb-2"
      data-i18n-key="fileListingError"
    >
      Something went wrong while fetching the file list
    </p>
    <p
      class="text-sm text-primaryMain has-text-centered"
      data-i18n-key="fileListingErrorDescription"
    >
      Please try again later
    </p>
  </div>
`;

export const downloadFileCardTemplate = htmlE`
        <div class="download-file-card is-flex is-align-items-center" ${({
          downloadType,
        }) => {
          // Only add title attribute if WS mode (where debug info is available)
          // The actual check for showServerReadProgress happens in the handler
          if (downloadType === "WS") {
            return `title="Alt+Click to copy debug information"`;
          }
          return "";
        }}>
        <div class="is-relative">
          <div class="download-file-card-icon-wrapper is-align-items-center is-justify-content-center is-flex">
            ${({ image }) => image || ""}
          </div>

            ${({ downloadType }) => {
              if (downloadType === "WS") {
                return ` <i class="download-type-badge text-accentMain icon-bolt"></i>`;
              }
            }}
          </div>
          <div class="download-file-card-details-container is-flex is-flex-direction-column is-justify-content-space-between">
            <div class="file-details-left-section is-flex is-flex-direction-column">
              <div class="is-flex is-align-items-center is-justify-content-space-between">
                ${({ name }) =>
                  `
                <p title="${utils.escapeHtmlAttr(
                  name || ""
                )}" class="text-sm whitespace-nowrap is-clipped is-ellipsis is-user-select-all">
                  ${utils.textEncode(name)}
                </p>
                `}
                <p class="text-xs whitespace-nowrap"><span>${"size"}</span>, <span>${"lastModifiedF"}</span></p>
              </div>

              <div class="is-flex is-align-items-center is-justify-content-space-between gap-3">
                <div class="is-flex is-align-items-center gap-3">
                ${({
                  completedPercentage,
                  downloadedBytes,
                  sizeInBytes,
                  showProgressBar,
                }) => {
                  return `<div class="progress-bar-container progress-bar${
                    !showProgressBar ? ` is-hidden` : ``
                  }">
                    <progress class="progress success-progress" value="${downloadedBytes}" max="${sizeInBytes}"></progress>
                </div>
                <span class="completed-percentage text-xs ${
                  !showProgressBar ? ` is-hidden` : ``
                }">${completedPercentage}</span>
                <div class="disk-write-info is-hidden text-xs">
                <div class="progress-bar-container disk-progress-container progress-bar">
                  <progress class="progress disk-progress"></progress>
                </div>
                (<i class="icon-save"></i> <span class="completed-percentage text-xs disk-completed-percentage"></span>
                <span class="disk-completed-speed text-xs"></span>)
                </div>
                </div>
                `;
                }}
            <div class="action-button-wrapper is-flex is-align-items-center">

            ${({ pauseButton, pauseText }) => {
              if (pauseButton) {
                return `
                <button class="primary-button is-bg-none p-1 text-xs pause-button">
                  <i class="icon-pause mr-2"></i>
                  <span data-i18n-key="pause">${pauseText}</span>
                </button>`;
              }
            }}

            ${({ waitingButton, waitingText }) => {
              if (waitingButton) {
                return `<span class="text-primaryMain text-sm"><span data-i18n-key="waiting">${waitingText}</span><span>...</span></span>`;
              }
            }}

            ${({ pausingButton, pausingText }) => {
              if (pausingButton) {
                return `<span class="text-primaryMain text-sm"><span data-i18n-key="pausing">${pausingText}</span><span>...</span></span>`;
              }
            }}

            ${({ cancelingButton, cancelingText }) => {
              if (cancelingButton) {
                return `<span class="text-primaryMain text-sm"><span data-i18n-key="canceling">${cancelingText}</span><span>...</span></span>`;
              }
            }}

            ${({ resumeButton, resumeText }) => {
              if (resumeButton) {
                return `
                <button class="primary-button is-bg-none p-1 text-xs resume-button">
                  <i class="icon-play mr-2"></i>
                  <span data-i18n-key="resume">${resumeText}</span>
                </button>`;
              }
            }}

            ${({ cancelButton, cancelText }) => {
              if (cancelButton) {
                return `
                <button class="primary-button is-bg-none p-1 text-xs cancel-button">
                  <i class="icon-remove mr-2"></i>
                  <span data-i18n-key="cancel">${cancelText}</span>
                </button>`;
              }
            }}

            ${({
              compressingButton,
              finalizingCopyingDataText,
              approxWritingTime,
              dependingOnMachineThisMayTakeApproxText,
            }) => {
              if (compressingButton) {
                return `
                <div class="writing-chunks-box p-3 is-absolute is-flex is-flex-direction-column is-align-items-center is-justify-content-center text-primaryMain h-full w-full">
                  <div>
                    <i class="icon-folder-open text-accentMain mr-2"></i>
                    <span class="text-sm" data-i18n-key="finalizingCopyingDataFromTempFileToFinalCompleteFilePleaseWait">${finalizingCopyingDataText}</span>
                  </div>
                  <p class="text-sm has-text-centered"><span data-i18n-key="dependingOnMachineThisMayTakeApprox">${dependingOnMachineThisMayTakeApproxText}</span> : <span>${approxWritingTime}</span></p>
                </div>`;
              }
            }}

            ${({ sandBoxDownloadMessage, sandBoxDownloadMessageText }) => {
              if (sandBoxDownloadMessage) {
                return `
                <div class="writing-chunks-box p-3 is-absolute is-flex is-flex-direction-column is-align-items-center is-justify-content-center text-primaryMain h-full w-full">
                  <div>
                    <i class="icon-folder-open text-accentMain mr-2"></i>
                    <span class="text-sm" data-i18n-key="sandBoxDownloadMessage">${sandBoxDownloadMessageText}</span>
                  </div>
                </div>`;
              }
            }}

            ${({ removeButton, removeText }) => {
              if (removeButton) {
                return `
                <button class="primary-button is-bg-none p-1 text-xs remove-button">
                  <i class="icon-trash mr-2 text-error"></i>
                  <span data-i18n-key="remove">${removeText}</span>
                </button>`;
              }
            }}
            </div>
              </div>

              <div class="is-flex is-justify-content-space-between">
              ${({
                speed,
                timeRemaining,
                elapsedTime,
                size,
                downloadedBytesFormatted,
                showProgressBar,
                elapsedText,
                remainingText,
                speedText,
                last10SecAverageSpeedText,
                last10SecAvgSpeed,
              }) => {
                return `
                <p class="error-message-left text-xs text-error">
                <span class="download-progress-status text-xs${
                  !showProgressBar ? ` is-hidden` : ``
                }">
                  <span class="fileSizeDownloaded">${downloadedBytesFormatted}</span> of <span class="fileSize">${size}</span> | <i class="icon-time"></i> : <b><span data-i18n-key="elapsed">${elapsedText}</span> / <span data-i18n-key="remaining">${remainingText}</span></b> :  <span class="elapsedTime">${elapsedTime}</span> / <span class="remainingTime">${timeRemaining}</span> | <b data-i18n-key="speed">${speedText}</b> :
                  <span class="downloadingSpeed">${speed}</span> |
                  <b data-i18n-key="last10SecAverageSpeed">${last10SecAverageSpeedText}</b> :
                  <span class="downloadingAvg10SecSpeed">${last10SecAvgSpeed}</span>
                </span>
              </p>
                `;
              }}


                <p class="error-message-right text-xs">
                  ${({
                    completionMessage,
                    timeTaken,
                    averageDownloadSpeed,
                  }) => {
                    if (completionMessage) {
                      return `<span data-i18n-key="downloadedInSecAtAnAverageSpeed" data-i18n-opt='{"time": "${timeTaken}", "speed" : "${averageDownloadSpeed}"}' class="text-primaryMain">${completionMessage}</span>`;
                    }
                  }}

                  ${({ downloadingError }) => {
                    if (downloadingError) {
                      return `<span class="ml-3 text-error">${utils.textEncode(downloadingError)}</span>
                        <i class="text-error icon-warning-sign"></i>`;
                    }
                  }}
                </p>
              </div>
            </div>

          </div>
        </div>`;

export const globalFileCardTemplate = htmlE`
  <div class="download-file-card is-flex is-align-items-center">
    <div class="download-file-card-details-container is-flex is-flex-direction-column is-justify-content-space-between">
      <div class="file-details-left-section is-flex is-flex-direction-column">
        <div class="is-flex is-align-items-center is-justify-content-space-between">
          ${({ name, downloadingText }) =>
            `
          <p title="${utils.escapeHtmlAttr(
            name || ""
          )}" class="text-sm whitespace-nowrap is-clipped is-ellipsis is-user-select-all mr-5">
            <b data-i18n-key="downloading">${utils.textEncode(
              downloadingText
            )}</b> : <span id="current-downloading-file-global">${utils.textEncode(
              name
            )}</span>
          </p>
          `}
          ${({ currentDownloadingFileNumber, totalDownloadingFiles }) =>
            `
          <p class="text-xs whitespace-nowrap ml-5">${currentDownloadingFileNumber} of total ${totalDownloadingFiles} item(s)</p>
          `}
        </div>

        <div class="is-flex is-align-items-center is-justify-content-space-between gap-3">
          <div class="is-flex is-align-items-center gap-3">
          ${({
            completedPercentage,
            totalBytesDownloaded,
            totalBytesToDownload,
            showProgressBar,
          }) => {
            return `<div class="progress-bar-container progress-bar${
              !showProgressBar ? ` is-hidden` : ``
            }">
              <progress class="progress success-progress" value="${totalBytesDownloaded}" max="${totalBytesToDownload}"></progress>
          </div>
          <span id="completed-percentage" class="text-xs${
            !showProgressBar ? ` is-hidden` : ``
          }">${completedPercentage}</span>
          </div>`;
          }}

      <div class="action-button-wrapper is-flex is-align-items-center">

      ${({ skipButton, skipText }) => {
        if (skipButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="skip-button">
            <i class="icon-forward mr-2"></i>
            <span data-i18n-key="skip">${skipText}</span>
          </button>`;
        }
      }}

      ${({ pauseButton, pauseText }) => {
        if (pauseButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="pause-button">
            <i class="icon-pause mr-2"></i>
            <span data-i18n-key="pause">${pauseText}</span>
          </button>`;
        }
      }}

      ${({ pausingButton, pausingText }) => {
        if (pausingButton) {
          return `<span class="text-primaryMain text-sm"><span data-i18n-key="pausing">${pausingText}</span><span>...</span></span>`;
        }
      }}

      ${({ cancelingButton, cancelingText }) => {
        if (cancelingButton) {
          return `<span class="text-primaryMain text-sm"><span data-i18n-key="canceling">${cancelingText}</span><span>...</span></span>`;
        }
      }}

      ${({ resumePauseButton, resumeText }) => {
        if (resumePauseButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="resume-pause-button">
            <i class="icon-play mr-2"></i>
            <span data-i18n-key="resume">${resumeText}</span>
          </button>`;
        }
      }}

      ${({ cancelButton, cancelText }) => {
        if (cancelButton) {
          return `
          <button class="primary-button is-bg-none p-1 text-xs" id="cancel-button">
            <i class="icon-remove mr-2"></i>
            <span data-i18n-key="cancel">${cancelText}</span>
          </button>`;
        }
      }}

      </div>
        </div>

        <div class="is-flex is-justify-content-space-between">
          <p class="error-message-left text-xs text-error">
            ${({ listingError }) => {
              if (listingError) {
                return `<i class="icon-warning-sign"></i>
                  <span>${utils.textEncode(listingError)}</span>`;
              }
            }}

            ${({
              showProgressBar,
              downloadedBytesFormatted,
              size,
              elapsedTime,
              timeRemaining,
              overAllSpeed,
              averageSpeedText,
              elapsedText,
              remainingText,
            }) => {
              return `<span class="download-progress-status${
                !showProgressBar ? ` is-hidden` : ``
              } text-xs">
                <span id="fileSizeDownloaded">${downloadedBytesFormatted}</span> of <span id="fileSize">${size}</span> | <i class="icon-time"></i> : <b><span data-i18n-key="elapsed">${elapsedText}</span> / <span data-i18n-key="remaining">${remainingText}</span></b> :  <span id="elapsedTime">${elapsedTime}</span> / <span id="remainingTime">${timeRemaining}</span> | <b data-i18n-key="averageSpeed">${averageSpeedText}</b> :
                <span id="downloadingAverageSpeed">${overAllSpeed}</span>
              </span>
            </p>`;
            }}

          <p class="error-message-right text-xs">
            ${({ completionMessage, timeTaken, averageDownloadingSpeed }) => {
              if (completionMessage) {
                return `<span data-i18n-key="downloadedInSecAtAnAverageSpeed" data-i18n-opt='{"time": "${timeTaken}", "speed" : "${averageDownloadingSpeed}"}' class="text-primaryMain">${completionMessage}</span>`;
              }
            }}
            ${({ downloadingError }) => {
              if (downloadingError) {
                return `<span class="text-error">${utils.textEncode(downloadingError)}</span>
                  <i class="text-error icon-warning-sign"></i>`;
              }
            }}
          </p>
        </div>
      </div>

    </div>
  </div>`;
